import { render, staticRenderFns } from "./NestedChildrenForms.vue?vue&type=template&id=76271108&scoped=true&"
import script from "./NestedChildrenForms.vue?vue&type=script&lang=js&"
export * from "./NestedChildrenForms.vue?vue&type=script&lang=js&"
import style0 from "./NestedChildrenForms.vue?vue&type=style&index=0&id=76271108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76271108",
  null
  
)

export default component.exports